import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getIsTimedPlusItemBiddingClosed } from '@/redux/modules/item/summary/itemSummary.selectors';
import { openRegisterForAuctionModal } from '@/redux/modules/modal';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import ItemBiddingSellSimilarButton from '@/components/ItemBidding/ItemBiddingSellSimilarButton';
import ItemBiddingStatusRow from '@/components/ItemBidding/ItemBiddingStatusRow';
import styled from 'styled-components';

export type TimedPlusItemBiddingNotRegisteredProps = {
    catalogId: number;
    isLive: boolean;
    itemId: number;
};

const TimedPlusItemBiddingNotRegistered = ({ catalogId, isLive, itemId }: TimedPlusItemBiddingNotRegisteredProps) => {
    const dispatch = useAppDispatch();
    const isClosed = useAppSelector((state) => getIsTimedPlusItemBiddingClosed(state, itemId));

    return (
        <StyledContent>
            <ItemBiddingStatusRow itemId={itemId} />
            <StyledButtonArea>
                {isClosed ? (
                    <ItemBiddingSellSimilarButton itemId={itemId} />
                ) : (
                    <Button
                        onClick={() => {
                            dispatch(
                                openRegisterForAuctionModal({
                                    catalogId,
                                    itemId,
                                })
                            );
                        }}
                        primary={!isLive}
                        red={isLive}
                    >
                        <FormattedMessage id="itemPage.biddingInfo.timedPlus.notStarted.registerForAuction" />
                    </Button>
                )}
            </StyledButtonArea>
        </StyledContent>
    );
};

export default TimedPlusItemBiddingNotRegistered;

const StyledContent = styled.div`
    flex: 1 1 auto;
    padding: 32px;
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        padding: 24px;
    }
    @media print {
        padding: 0;
    }
    & > a {
        display: block;
    }
    & > *:last-child {
        margin-bottom: 0;
    }
    > div:not(:first-child),
    a {
        @media print {
            display: none;
        }
    }
    > div:first-child {
        @media print {
            margin: 0;
        }
    }
`;

const StyledButtonArea = styled.div`
    width: 100%;
    margin-top: 24px;
    text-transform: uppercase;

    > button {
        width: 100%;
    }
`;
